module.exports = __webpack_public_path__ + "img/way-to-go.2487257f.jpg";